import { gql } from 'apollo-angular';

export const LINE_ITEM_PRICE_HISTORY_SUMMARY_FRAGMENT = gql`
fragment LineItemPriceHistorySummary on LineItemPriceHistorySummary {
    avgUnitPrice
    weightedAvgUnitPrice
    peakUnitPrice
    minUnitPrice
    totalQuantity
    transactionCount
    totalRevenue
    currentDelta
    currentDeltaPercent
    manualOverrideRate
    priceVolatility
    firstUnitPrice
    lastUnitPrice
    periodChangePercent
    currentListPrice
    avgReferenceListDelta
    avgUnitMargin
    avgMarginPercent
    currency
    currencyMixed
}
`;

export const LINE_ITEM_PRICE_HISTORY_ENTRY_FRAGMENT = gql`
fragment LineItemPriceHistoryEntry on LineItemPriceHistoryEntry {
    date
    documentId
    documentIdentifier
    documentType
    documentStatus
    lineItemId
    quantity
    unitPrice
    referenceListUnitPrice
    documentPriceListUnitPrice
    referenceListDelta
    referenceListDeltaPercent
    calculatoryCosts
    calculatoryCostsTotal
    unitMargin
    marginPercent
    priceSource
    delta
    deltaPercent
    lineTotal
    discountPercentage
    discountPercentage2
    currency
}
`;

export const GET_LINE_ITEM_PRICE_HISTORY = gql`
query GetLineItemPriceHistory($input: LineItemPriceHistoryInput!) {
    lineItemPriceHistory(input: $input) {
        summary {
            ...LineItemPriceHistorySummary
        }
        items {
            ...LineItemPriceHistoryEntry
        }
    }
}
${LINE_ITEM_PRICE_HISTORY_SUMMARY_FRAGMENT}
${LINE_ITEM_PRICE_HISTORY_ENTRY_FRAGMENT}
`;
